"use client";

import { Product } from "@/types/product";
import PurchaseNotification from "../notifications/PurchaseNotification";
import useSWR from "swr";

const fetcher = (url: string) => fetch(url).then((res) => res.json());

interface ProductsResponse {
	products: Product[];
}

export default function PurchaseNotificationProvider() {
	const { data: products, error } = useSWR<ProductsResponse>(
		"/api/products",
		fetcher,
		{
			revalidateOnFocus: false,
			revalidateOnReconnect: false,
		}
	);

	if (error || !products) return null;

	return <PurchaseNotification products={products} />;
}
